/**
 * GraphQL Queries for Complex Process
 * 
 * Centralized query definitions
 */

export const ComplexProcessQueries = {
    LIST_PROCESSES: `
        query ListComplexProcesses(
            $tenant: String!
            $filter: ComplexProcessFilter
            $pagination: PaginationInput
            $sort: SortInput
        ) {
            listComplexProcesses(
                tenant: $tenant
                filter: $filter
                pagination: $pagination
                sort: $sort
            ) {
                items {
                    id
                    name
                    domain
                    description
                    complexity
                    avgDuration
                    stages {
                        id
                        name
                        stageType
                        actors
                        steps {
                            id
                            name
                            actor
                            stepType
                            external
                            conditional
                            loops
                            triggers
                            outputs
                            estimatedDuration
                        }
                        loops
                        parallelTracks
                        estimatedDuration
                        position
                        color
                    }
                    connections {
                        id
                        from
                        to
                        connectionType
                        condition
                        label
                        probability
                        avgTransitionTime
                    }
                    actors
                    externalSystems {
                        id
                        name
                        systemType
                        integrationPoints
                        dataFormats
                        authentication
                    }
                    metrics {
                        totalSteps
                        uniqueActors
                        loopingStages
                        externalIntegrations
                        decisionPoints
                        avgComplexityScore
                        estimatedTotalDuration
                    }
                    isTemplate
                    version
                    parentId
                    createdAt
                    updatedAt
                    createdBy
                    active
                    metadata
                }
                total
                hasNext
                cursor
            }
        }
    `,

    GET_PROCESS: `
        query GetComplexProcess($tenant: String!, $id: String!) {
            getComplexProcess(tenant: $tenant, id: $id) {
                id
                name
                domain
                description
                complexity
                avgDuration
                stages {
                    id
                    name
                    stageType
                    actors
                    steps {
                        id
                        name
                        actor
                        stepType
                        external
                        conditional
                        loops
                        triggers
                        outputs
                        estimatedDuration
                        metadata
                    }
                    loops
                    parallelTracks
                    estimatedDuration
                    position
                    color
                }
                connections {
                    id
                    from
                    to
                    connectionType
                    condition
                    label
                    probability
                    avgTransitionTime
                }
                actors
                externalSystems {
                    id
                    name
                    systemType
                    integrationPoints
                    dataFormats
                    authentication
                }
                metrics {
                    totalSteps
                    uniqueActors
                    loopingStages
                    externalIntegrations
                    decisionPoints
                    avgComplexityScore
                    estimatedTotalDuration
                }
                isTemplate
                version
                parentId
                createdAt
                updatedAt
                createdBy
                active
                metadata
            }
        }
    `,

    GET_PROCESS_VERSIONS: `
        query GetProcessVersions($tenant: String!, $processId: String!) {
            getProcessVersions(tenant: $tenant, processId: $processId) {
                items {
                    id
                    version
                    createdAt
                    createdBy
                    changesSummary
                }
            }
        }
    `,

    SEARCH_PROCESSES: `
        query SearchProcesses(
            $tenant: String!
            $query: String!
            $domains: [String!]
            $complexities: [String!]
            $limit: Int
        ) {
            searchProcesses(
                tenant: $tenant
                query: $query
                domains: $domains
                complexities: $complexities
                limit: $limit
            ) {
                items {
                    id
                    name
                    domain
                    description
                    complexity
                    score
                    snippet
                }
                total
            }
        }
    `,

    GET_PROCESS_STATISTICS: `
        query GetProcessStatistics($tenant: String!) {
            getProcessStatistics(tenant: $tenant) {
                totalProcesses
                totalTemplates
                totalCustom
                byDomain {
                    domain
                    count
                }
                byComplexity {
                    complexity
                    count
                }
                avgStages
                avgActors
                avgConnections
                mostUsedActors {
                    actor
                    count
                }
                mostUsedSystems {
                    system
                    count
                }
            }
        }
    `,

    GET_PROCESS_TEMPLATES: `
        query GetProcessTemplates(
            $tenant: String!
            $domain: String
        ) {
            getProcessTemplates(
                tenant: $tenant
                domain: $domain
            ) {
                items {
                    id
                    name
                    domain
                    description
                    complexity
                    previewImage
                    usageCount
                    rating
                    tags
                }
            }
        }
    `,

    VALIDATE_PROCESS: `
        query ValidateProcess(
            $tenant: String!
            $process: ComplexProcessInput!
        ) {
            validateProcess(
                tenant: $tenant
                process: $process
            ) {
                valid
                errors {
                    field
                    message
                    severity
                }
                warnings {
                    field
                    message
                }
                suggestions {
                    type
                    message
                    action
                }
            }
        }
    `,

    GET_PROCESS_EXECUTION_HISTORY: `
        query GetProcessExecutionHistory(
            $tenant: String!
            $processId: String!
            $limit: Int
        ) {
            getProcessExecutionHistory(
                tenant: $tenant
                processId: $processId
                limit: $limit
            ) {
                items {
                    id
                    instanceId
                    startedAt
                    completedAt
                    status
                    currentStage
                    completedStages
                    errors {
                        stage
                        message
                        timestamp
                    }
                    metrics {
                        duration
                        stagesCompleted
                        errorsCount
                    }
                }
            }
        }
    `
};

export default ComplexProcessQueries;
